import { render, staticRenderFns } from "./AppBrands.vue?vue&type=template&id=679f60aa&"
import script from "./AppBrands.vue?vue&type=script&lang=js&"
export * from "./AppBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports